import axios from "axios";

export default axios.create({
    baseURL: "https://pinnydb-api.netlify.app/.netlify/functions",
//    baseURL: "https://us-west-2.aws.webhooks.mongodb-realm.com/api/client/v2.0/app/pinnydb-new-rtkfa/service/Pins/incoming_webhook",
//    baseURL: "https://us-west-2.aws.webhooks.mongodb-realm.com/api/client/v2.0/app/pinnydb-sktje/service/Pins/incoming_webhook",
//    baseURL: "https://figpindb-backend.herokuapp.com/api/v1/pinnydb",
    headers: {
        "Content-type": "application/json"
    }
});
